import React from 'react';
import {BiMailSend} from 'react-icons/bi';
import {BsFacebook, BsInstagram} from 'react-icons/bs';
import {NavLink} from 'react-router-dom';
import logo from '../../assets/wimpel.webp';
import ExternalLink from '../ExternalLink';
import './footer.css';

const Footer = () => (
    <footer className="footer">
        <div className="footer-inner">
            <div className="footer-brand">
                <img src={logo} alt="VCH Logo" loading="lazy"/>
                <p>
                    <strong>Union Volleyballclub</strong>
                    <br/>
                    Hausmannstätten-Vasoldsberg
                </p>
            </div>

            <div>
                <p className="footer-heading">Folge uns</p>
                <div className="footer-social">
                    <ExternalLink href="https://instagram.com/vch_hausmannstaetten"><BsInstagram title="Instagram"/></ExternalLink>
                    <ExternalLink href="https://www.facebook.com/VolleyballClubHausmannstaetten"><BsFacebook title="Facebook"/></ExternalLink>
                    <a href="mailto:news-subscribe@vch-online.at?subject=Newsletter%20abonnieren">
                        <BiMailSend title="Newsletter abonnieren"/>
                    </a>
                </div>
            </div>

            <div>
                <p className="footer-heading">Rechtliches</p>
                <nav className="footer-legal" aria-label="Rechtliches">
                    <NavLink to="/impressum">Impressum</NavLink>
                    <NavLink to="/datenschutz">Datenschutz</NavLink>
                    <NavLink to="/cookies">Cookies</NavLink>
                </nav>
            </div>
        </div>
        <p className="footer-bottom">© {new Date().getFullYear()} Union Volleyballclub Hausmannstätten-Vasoldsberg</p>
    </footer>
);

export default Footer;
